<template>
  <div>
    <div class="upload-img-box" @paste="onPaste">
      <el-upload class="avatar-uploader" :action="uploadUrl" name="upload" :show-file-list="false"
        :on-success="handleAvatarSuccess" :on-error="uploadError"
        accept="image/jpeg, image/png, image/jpg, image/gif, image/webp" :style="{ width: width, height: height }"
        ref="multipleUpload" list-type="picture" :headers="header" :data="id ? { id: id } : {}">
        <div v-if="cover" class="preview-box">
          <img :src="imgUrl + cover" class="avatar" @click.stop="preview" />
          <div class="hover-cover">
            <i class="el-icon-view" @click.stop="preview"></i>
            <i class="el-icon-upload"></i>
          </div>
        </div>
        <i v-else class="el-icon-plus avatar-uploader-icon" :style="{ lineHeight: height }"></i>
      </el-upload>
      <p class="desc" v-if="isShow">
        <slot name="desc">
          <span>图片大小最好不要超过1M,且宽高度最好为{{ this.wSize + '*' + this.hSize }}</span>
        </slot>
      </p>
    </div>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
  </div>
</template>
<script>
import MediaPopup from '@/components/media-popup'
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import api from '@/api'
export default {
  components: { MediaPopup },
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      cropperModel: false,
      // 当前选中的文件（未压缩裁剪之前）
      checkedFile: "",
      // 传递到裁剪框中的图片路径
      imgFile: "",
      header: {
        Authorization: local.get("userInfo").token
      },
      lockImg: '',
    };
  },
  props: ["cover", "width", "height", "id", "wSize", "hSize", "hide"],
  computed: {
    isShow() {
      return this.hide ? false : true;
    }
  },
  methods: {
    // // 图片上传前验证
    // beforeAvatarUpload(file) {
    //   const isLt3M = file.size / 1024 / 1024 < 0.5;
    //   if (!isLt3M) {
    //     this.$message.error("封面上传大小不能超过500kb");
    //     return false
    //   }
    // },
    // 视频封面上传成功回掉
    handleAvatarSuccess(res) {
      if (res.code === 200) {
        this.$emit("successCallback", res);
      } else {
        this.$message.error("上传封面图失败");
      }
    },

    onPaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      // 此时file就是我们的剪切板中的图片对象   
      this.file = file
      this.uploadPlans()
    },

    // 上传文件成功后回调
    uploadPlans() {
      const file = this.file
      if (!file) {
        this.$message.error('请粘贴图片后上传')
        return
      }
      this.loading = true
      const form = new FormData()
      form.append('upload', file)
      form.append('type', this.type)
      api.uploadImg(form).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '上传成功!'
          })
          this.lockImg = res.data.coverImg
          this.changeImgUrl()
        } else {
          this.$message({
            type: 'error',
            message: '上传失败!'
          })
          this.lockImg = ''
        }
      })
    },

    changeImgUrl() {
      this.$emit('changeImgUrl', this.lockImg)
    },

    // 图片上传错误
    uploadError() {
      this.$message.error("上传封面图失败");
    },

    preview() {
      this.$refs.mediaPopup.open(this.imgUrl + (this.cover || this.lockImg), 'img')
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-popup {
  .el-dialog {
    margin-top: 0px !important;
  }
}

.upload-img-box {
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-icon-plus {
    height: 100% !important;
  }

  .preview-box {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .hover-cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #0008;
      opacity: 0;
      transition: all 0.25s ease-in;
      color: white;
      font-size: 25px;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        margin: 5px;
      }
    }

    &:hover {
      .hover-cover {
        opacity: 1;
      }
    }
  }

  img {
    width: 100%;
    height: 100%;
  }

  /deep/ .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }
  }

  .desc {
    line-height: 1;
    margin-top: 10px;
    color: #999;
    font-size: 12px;
  }

  .avatar-uploader-icon {
    width: 100%;
    height: 100%;
    font-size: 28px;
    color: #8c939d;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
